import { PushNotificationDao } from "./PushNotificationDao";
import { useMemo } from "react";

export const usePushNotificationDao = () => {
  return useMemo(() => new PushNotificationDao(), []);
};
